module.exports = __webpack_public_path__ + "static/img/TMBcharacterPhotos_0002_mrNancy.313a57b.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/TMBcharacterPhotos_0002_mrNancy.jpg
// module id = D/8p
// module chunks = 1